import React from 'react';
import { WindowControls } from './WindowControls';

/**
 * Giriş, yasal onay, yükleme ve hata ekranlarının çerçevesi. Pencere
 * çerçevesiz (`frame: false`) olduğu için başlık çubuğunu uygulama çiziyor;
 * ana düzendeki TopBar bu ekranlarda yok. Bu şerit olmadan pencere
 * sürüklenemiyor, küçültülemiyor ve kapatılamıyordu.
 */
export const GateFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="h-dvh w-full flex flex-col bg-[#111113]">
    <div className="app-drag-region h-10 shrink-0 flex items-center justify-end px-3 select-none">
      <div className="app-no-drag">
        <WindowControls isDarkMode />
      </div>
    </div>
    <div className="flex-1 min-h-0">{children}</div>
  </div>
);
